module.exports = [
  {
    path: 'login/landing',
    redirect: 'landing',
  },
  {
    path: 'login',
    name: 'Login',
    component: 'Login',
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: 'landing',
    name: 'Landing',
    component: 'Landing',
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: 'registration',
    name: 'Registration',
    component: 'RegistrationAnon',
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: 'forgot-password',
    name: 'ForgotPassword',
    component: 'ForgotPassword',
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: 'reset-password/:userHash/:language',
    name: 'ResetPassword',
    component: 'ResetPassword',
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: 'account-activation',
    name: 'AccountActivation',
    component: 'AccountActivation',
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: 'activation/:userHash/:language',
    name: 'ActivationLogin',
    component: 'ActivationLogin',
    meta: {
      layout: 'Landing',
    },
  },
  {
    path: 'profileChooser',
    name: 'ProfileChooser',
    component: 'ProfileChooser',
    meta: {
      layout: 'Dashboard',
      profileSpecific: false,
      link: {
        name: 'Home',
        icon: 'IconHome',
        to: { name: 'ProfileChooser' },
        rank: 5,
      },
    },
  },
  {
    path: 'home',
    name: 'Home',
    component: 'Home',
    meta: {
      layout: 'Dashboard',
      profileSpecific: true,
      link: {
        icon: 'IconHome',
        to: { name: 'Home' },
        rank: 10,
      },
    },
  },
  {
    path: 'FAQ',
    name: 'FAQ',
    component: 'FAQ',
    meta: {
      layout: 'Dashboard',
      profileSpecific: false,
      link: {
        icon: 'IconFAQ',
        to: { name: 'FAQ' },
        rank: 40,
      },
    },
  },
  {
    path: 'profile',
    name: 'Profile',
    component: 'Profile',
    meta: {
      layout: 'Dashboard',
      profileSpecific: false,
      link: {
        icon: 'IconProfile',
        to: { name: 'Profile' },
        rank: 20,
      },
    },
  },
  {
    path: 'assessment',
    name: 'ModuleArea',
    component: 'ModuleArea',
    meta: {
      profileSpecific: true,
      layout: 'Dashboard',
    },
    props: true,
  },
  {
    path: 'report',
    name: 'Report',
    component: 'Report',
    meta: {
      layout: 'Dashboard',
      profileSpecific: true,
      link: {
        icon: 'IconErgebnisbericht',
        to: { name: 'Report' },
        rank: 60,
      },
    },
  },
  {
    path: 'support',
    name: 'Support',
    component: 'Support',
    meta: {
      layout: 'Dashboard',
      profileSpecific: false,
      link: {
        icon: 'IconSupport',
        to: { name: 'Support' },
        rank: 70,
      },
    },
  },
  {
    path: 'page-not-found',
    name: 'Custom_PageNotFound',
    component: 'PageNotFound',
    meta: {
      layout: 'Error',
    },
  },
  {
    path: '*',
    redirect: '/page-not-found',
  },
];
